import { ConfigService } from '../../services/config.service';
import { ModalController } from '@ionic/angular';
import { IapService } from '../../services/iap.service';
import { Team } from '../../models/team.model';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from '@ionic/angular';
import { AppTrial } from '../../models/app-trial.model';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'iap-modal',
  templateUrl: 'iap-modal.html',
  styleUrls: ['./iap-modal.scss'],
})
export class IAPModal implements OnInit, OnChanges {
  // Data passed in by componentProps
  @Input() teamId: string;
  @Input() message: string;
  @Input() messages: string;
  @Input() title: string;
  @Input() placeholder: string;
  @Input() trial: AppTrial;
  @Input() team: Team;
  @Input() isUserAdmin: boolean;

  blocked = false;

  constructor(
    private analytics: AnalyticsService,
    public modalCtrl: ModalController,
    public toastController: ToastController,
    public iap: IapService,
    public config: ConfigService,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    console.log('IAP - ngOnInit()');
  }

  ngOnChanges(changes) {
    console.log('changes', changes);
    console.log('Recheck status in case purchase was pending and just made');
    if (this.blocked) {
      console.log('BLOCKED');
      if (!this.iap.hasValidPlan(this.isUserAdmin, this.trial, this.team)) {
        console.log('invalid plan, block the team');
        this.analytics.track('qt_iap_invalid_block', { team_id: this.teamId });
        this.blocked = true;
      } else {
        console.log('valid plan, unblock the team');
        this.analytics.track('qt_iap_valid_unblock', { team_id: this.teamId });
        this.blocked = false;
        this.dismiss();
      }
    } else {
      console.log('NOT blocked');
      this.analytics.track('qt_iap_not_blocked', { team_id: this.teamId });
      // this.setFormValues();
      this.dismiss();
    }
  }

  dismiss() {
    this.analytics.track('qt_iap_dismissed', {
      team_id: this.teamId,
    });
    this.modalCtrl.dismiss();
  }
}
